import { useState, useEffect } from 'react';
import { usePublicConfig } from './publicConfig';

/**
 * WalletConnect 接入（E 链手机端用户）。
 * projectId 从后台配置 wc_project_id 读取（需在 https://cloud.reown.com 注册获取）。
 * 返回 { wcProvider, connecting, connect }：连接成功后 wcProvider 可替代 window.ethereum 使用。
 */

let cachedProvider = null;

export const useWalletConnect = () => {
  const cfg = usePublicConfig();
  const projectId = cfg['wc_project_id'];
  const [wcProvider, setWcProvider] = useState(cachedProvider);
  const [connecting, setConnecting] = useState(false);
  const [error, setError] = useState('');

  const connect = async () => {
    if (!projectId) {
      setError('WalletConnect 未配置');
      return null;
    }
    setConnecting(true);
    setError('');
    try {
      const { EthereumProvider } = await import('@walletconnect/ethereum-provider');
      const { WalletConnectModal } = await import('@walletconnect/modal');
      const modal = new WalletConnectModal({ projectId });
      const provider = await EthereumProvider.init({
        projectId,
        chains: [1, 56],
        optionalChains: [1, 56],
        showQrModal: true,
        methods: [
          'eth_sendTransaction', 'eth_signTypedData_v4', 'personal_sign',
          'eth_call', 'eth_requestAccounts', 'eth_getTransactionReceipt',
        ],
        qrModalOptions: { themeMode: 'light' },
      });
      await modal.subscribeProvider(provider);
      const accounts = await provider.request({ method: 'eth_requestAccounts' });
      if (!accounts || !accounts.length) throw new Error('未连接钱包');
      cachedProvider = provider;
      setWcProvider(provider);
      return provider;
    } catch (e) {
      setError(String(e.message || e));
      return null;
    } finally {
      setConnecting(false);
    }
  };

  return { wcProvider, connecting, error, connect };
};
